import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import signalsPlugin from '@backstage/plugin-signals/alpha';
import doraMetricsPlugin from '@c2l2c/backstage-plugin-dora-metrics/alpha';
import catalogImportPlugin from '@backstage/plugin-catalog-import/alpha';
import { oidcSessionLogout } from 'plugin-app-module-adp-oidc-session-logout';
import { apisModule } from './modules/apis';
import { appOptionsModule } from './modules/app';
import { catalogEntityPageModule } from './modules/catalog';
import { navModule } from './modules/nav';
import { proxyAuthModule } from './modules/proxyAuth';
import { rbacModule } from './modules/rbac';
import { routeModule } from './modules/route';
import { scaffolderArgoDexTokenModule } from './modules/scaffolder/ArgoDexTokenFormDecorator';
import { scaffolderGitflicFieldModule } from './modules/scaffolder/GitflicOAuthFieldExtension';
import { techDocsVersionSelectorModule } from './modules/techdocs';
import { translations } from './translation';

const translationsModule = createFrontendModule({
  pluginId: 'app',
  extensions: translations.map(resource =>
    TranslationBlueprint.make({
      name: resource.id,
      params: { resource },
    }),
  ),
});

export default createApp({
  features: [
    apisModule,
    appOptionsModule,
    catalogPlugin,
    catalogImportPlugin,
    catalogEntityPageModule,
    doraMetricsPlugin,
    navModule,
    proxyAuthModule,
    rbacModule,
    oidcSessionLogout,
    routeModule,
    scaffolderArgoDexTokenModule,
    scaffolderGitflicFieldModule,
    signalsPlugin,
    techDocsVersionSelectorModule,
    translationsModule,
  ],
});
